import { render, staticRenderFns } from "./VentureEdit.vue?vue&type=template&id=32abd89a"
import script from "./VentureEdit.vue?vue&type=script&lang=js"
export * from "./VentureEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports